import { createContext, useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [skuIds, setSkuIds] = useState([]);
  const [defaultProductsDetails, setDefaultProductsDetails] = useState([]);
  const [dataProductos, setDataProductos] = useState(null);
  const [dataTextos, setDataTextos] = useState(null);
  const [addedToCart, setAddedToCart] = useState(false);
  const [loadingCart, setLoadingCart] = useState(false);
  const [messageAddToCart, setMessageAddToCart] = useState(null);

  const fetchProductDetails = async (areaCalculada) => {
    try {
      return getProducts(skuIds);
    } catch (error) {
      console.error("Error al obtener detalles del producto:", error);
    }
  };

  const getProducts = async (skuIds) => {
    try {
      const products = skuIds.map((skuId) => ({ skuId }));
      const queryString = encodeURIComponent(JSON.stringify({ products }));
      const response = await axios.get(
        `https://www.falabella.com/s/browse/v1/fetchItemDetails/cl?${queryString}`
      );
      // console.log("Detalles del producto:", response.data.products);
      return response.data.products;
    } catch (error) {
      console.error("Error al obtener detalles del producto:", error);
    }
  };

  const addToCart = async (materiales) => {
    setLoadingCart(true);
    const cartLines = materiales.map((material) => ({
      cartLineNumber: material.id,
      item: { variantId: material.id, offeringId: material.offeringId },
      quantity: { quantityNumber: material.cantidad, quantityUnit: "C/U" },
    }));

    try {
      const headers = {
        "content-type": "application/json",
        "x-channel-id": "WEB",
        "x-commerce": "FCM",
        "x-ecomm-name": "marketplacesodimac-cl",
        "x-origin-name": "PDP",
        "x-origin-view": "Product",
        "x-site-name": "sodimac",
      };

      const body = {
        data: {
          cart: {
            cartLines: cartLines,
          },
        },
        metadata: {
          priceGroup: "96",
          politicalAreaId: "15c37b0b-a392-41a9-8b3b-978376c700d5",
        },
      };

      // obtener cartId de las cookies
      const existingCartId = Cookies.get("cartId");
      // si existe un cartId los agregará a la URL y agregará los productos a ese carro
      // de lo contrario, creará uno nuevo
      const query = existingCartId ? `?cartId=${existingCartId}` : "";
      
      // hacer la solicitud con cartId si existe
      const response = await axios.post(
        `https://www.sodimac.cl/s/checkout/v1/carts${query}`,
        body,
        { headers }
      );

      const cartId = response.data.data.cart.cartId;
      if (cartId) {
        if (cartId) {
          Cookies.set("cartId", cartId, {
            expires: 7,
            domain: ".sodimac.cl",
          });
          // console.log("Nuevo cartId almacenado en cookies:", cartId);
        }
      }

      setAddedToCart(true);
      setLoadingCart(false);
      setMessageAddToCart('success');
      return response.data;
    } catch (error) {
      setLoadingCart(false);
      setMessageAddToCart('failed');
      console.error("Error al agregar productos al carrito:", error);
    }
  };

  useEffect(() => {
    const fetchProjectData = async () => {
      const referrer = document.referrer; // Obtiene la URL de la página que contiene el iframe
      // console.log(document);
      const match = referrer.match(/content\/([^?]+)/); // Extrae el segmento después de "contect/" y antes de "?"
      // console.log(match);
      // console.log("https://www.sodimac.cl/static/proyectos-radier/calculadora-proyectos-json/"+match+".json");

      try {

        if (match) {
          // console.log(match[0]);
          const response = await axios.get("https://www.sodimac.cl/static/proyectos/agregaralcarro-json/"+match[0]+".json");
  
          setDataProductos(response.data.productos);
          setDataTextos(response.data.textos[0]);
    
          const skus = Object.values(response.data.productos).map((producto) => producto.sku);
          const defaultProductsDetails = Object.values(response.data.productos).reduce((prodBySku, producto) => {
            prodBySku[producto.sku] = producto;
            return prodBySku;
          }, {});

          // console.log('defaultProductsDetails');
          // console.log(defaultProductsDetails);
          
          setSkuIds(skus);
          setDefaultProductsDetails(defaultProductsDetails);

        } else {
          const response = await axios.get("https://www.sodimac.cl/static/proyectos/agregaralcarro-json/calculadora-proyectos.json");
          // const response = await axios.get("/calculadora-proyectos.json");
  
          setDataProductos(response.data.productos);
          setDataTextos(response.data.textos[0]);
    
          const skus = Object.values(response.data.productos).map((producto) => producto.sku);
          const defaultProductsDetails = Object.values(response.data.productos).reduce((prodBySku, producto) => {
            prodBySku[producto.sku] = producto;
            return prodBySku;
          }, {});

          // console.log('defaultProductsDetails');
          // console.log(defaultProductsDetails);
          
          setSkuIds(skus);
          setDefaultProductsDetails(defaultProductsDetails);
        }
  
      } catch (error) {
        console.error("Error al cargar datos del proyecto:", error);
      }
    };
  
    fetchProjectData();
  }, []);


  /**
  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        // Cargar JSON local desde /public
        const response = await axios.get("/calculadora-proyectos.json");

        setDataProductos(response.data.productos);
        setDataTextos(response.data.textos[0]);

        const skus = Object.values(response.data.productos).map((producto) => producto.sku);
        const defaultProductsDetails = Object.values(response.data.productos).reduce((prodBySku, producto) => {
          prodBySku[producto.sku] = producto;
          return prodBySku;
        }, {});

        setSkuIds(skus);
        setDefaultProductsDetails(defaultProductsDetails);

      } catch (error) {
        console.error("Error al cargar datos del JSON local:", error);
      }
    };

    fetchProjectData();
  }, []);**/



  const globalReset = () => {
    setMessageAddToCart(null);
    setAddedToCart(false);
  };

  return (
    <DataContext.Provider
      value={{
        fetchProductDetails,
        getProducts,
        addToCart,
        dataProductos,
        dataTextos,
        defaultProductsDetails,
        addedToCart,
        setAddedToCart,
        loadingCart,
        messageAddToCart,
        setMessageAddToCart,
        globalReset
      }}
    >
      {children}
    </DataContext.Provider>
  );
};